import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { Capability } from '../../models/service/capability';
import { MatDialog } from '@angular/material/dialog';
import { CapabilityDetailsComponent } from 'src/app/components/capability-details/capability-details.component';
import { CapabilitiesService } from 'src/app/services/api/capabilities.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  }
];

@Component({
    selector: 'app-capability-card',
    templateUrl: './capability-card.component.html',
    styleUrls: ['./capability-card.component.scss'],
    standalone: false
})
export class CapabilityCardComponent implements OnInit {

  @Input() capability: Capability;
  @Input() showLink = true;
  @Input() selectable = true;
  @Input() isUpdated = true;
  @Input() capabilityDescription: Capability[];
  @Output() selectionChanged = new EventEmitter();
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  isPopupOpened = false;
  private destroyRef = inject(DestroyRef);

  constructor(private matDialog: MatDialog, private capabilitiesService: CapabilitiesService,
    private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
  //TODO: Below code required to enable and modify when extend sandbox / service is enabled.
    /*if (this.isUpdated) {
      this.capability.selected = this.isUpdated;
    }*/
  }

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
  }

  async viewDetails(): Promise<void> {
    (await this.capabilitiesService.getCapabilitiesView({ name: this.capability.name, version: this.capability.version }))
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (!this.isPopupOpened) {
        this.viewDetailsDescription(response);
      }
    });
  }

  viewDetailsDescription(response): void {
    if(response) {
      this.isPopupOpened = true;
      this.matDialog.open(CapabilityDetailsComponent, {
        minHeight: '533px',
        width: '760px',
        panelClass: 'flex-dialog',
        data: {
          capability: this.capability,
          selectable: this.selectable,
          capabiltyDisabled: this.capability.disabled,
          description: response.description,
          version: response.version,
          releaseVersion: response.releaseVersion,
          isAMR: response.isAMR
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.isPopupOpened = false;
        if (result) {
          this.isPopupOpened = true;
          this.selectionChanged.emit(this.capability);
        }
      });
    }
  }
}
